import React, { useMemo } from "react";
import RRLegajo from "../renderRows/RRLegajo";

import './LegajosList.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeftLong } from "@fortawesome/free-solid-svg-icons";

import { useNavigate } from "react-router-dom";
import { checkDoubleQuotes, removeDoubleQuotesFromFilter } from "../../utils/funciones";
import normalizeText from "../../utils/normalizeText";

const LegajosList = ({legajosList, filter, handleEditLegajo}) =>{

    const navigate = useNavigate();

    let legajosFiltered = useMemo(()=> legajosList.filter(l => {
        return filter != '' ? 
            checkDoubleQuotes(filter) ?
                (normalizeText(l.codigo) == removeDoubleQuotesFromFilter(filter) || normalizeText(l.nombre) == removeDoubleQuotesFromFilter(filter) || normalizeText(l.catego) == removeDoubleQuotesFromFilter(filter))
            :
                (normalizeText(l.codigo).includes(normalizeText(filter)) || normalizeText(l.nombre).includes(normalizeText(filter)) || normalizeText(l.catego).includes(normalizeText(filter)))
        : true
    }), [legajosList, filter]);

    return <div className="legajosListDiv">
        <button onClick={()=>navigate('/abms')} className="goBackBtn"><FontAwesomeIcon className="iconArrowBack" icon={faArrowLeftLong}/></button>
        {legajosFiltered.map((l,i) => <RRLegajo key={`${i}-${l.codigo}`} l={l} index={i} handleEditLegajo={handleEditLegajo}/>)}
    </div>

}

export default LegajosList;